// components/inventory/ActionButtons.jsx
import React from 'react';
import { Eye, Edit, Plus, Share2, Trash2 } from 'lucide-react';
import ActionButton from '../ui/ActionButton';

const ActionButtons = ({ 
  onView, 
  onEdit, 
  onAddItem, 
  onShare, 
  onDelete,
  showView = true,
  showEdit = true,
  showAddItem = true,
  showShare = true,
  showDelete = true
}) => {
  return (
    <div className="flex justify-center gap-2">
      {showView && (
        <ActionButton 
          onClick={onView} 
          color="blue" 
          icon={<Eye size={14} />} 
          title="View Inventory" 
        />
      )}
      
      {showEdit && (
        <ActionButton 
          onClick={onEdit} 
          color="green" 
          icon={<Edit size={14} />} 
          title="Edit Inventory" 
        />
      )}
      
      {showAddItem && (
        <ActionButton 
          onClick={onAddItem} 
          color="purple" 
          icon={<Plus size={14} />} 
          title="Add Items" 
        />
      )}
      
      {showShare && (
        <ActionButton 
          onClick={onShare} 
          color="orange" 
          icon={<Share2 size={14} />} 
          title="Share Inventory" 
        />
      )}
      
      {showDelete && (
        <ActionButton 
          onClick={onDelete} 
          color="red" 
          icon={<Trash2 size={14} />} 
          title="Delete Inventory" 
        />
      )}
    </div>
  );
};

export default ActionButtons;